export enum BOTemplate {
  PARTS = 'parts',
  PRO = 'pro',
}
